import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import LinkDownload from '../../components/link/link-download';
import LabelCategory from '../../components/label/label-category.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import env from '../../environment.js';
import NoPagination from '../../components/pagination/noPagination.jsx';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import ListToolbar, { BtnNuevo, BtnCancelar } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import Swal from 'sweetalert2';
import ModalPadronAltas from '../../components/modal/modal-padron-altas-bajas.jsx';
import CheckboxList from '../../components/forms/checkbox-list.jsx';
import ModalPadronAltasBajasCancelar from '../../components/modal/modal-padron-altas-bajas-cancelar.jsx';
import TabButtons from '../../components/link/tab-buttons.jsx';

const PadronBajasList = () => {
  const auth = useAuth();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const [btnPendientes, setBtnPendientes] = useState(true);

  const report = 'padron_bajas';
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  // const [prodSeleccionados, setProdSeleccionados] = useState([]);
  const [confirmBajas, setConfirmBajas] = useState(false);
  const dialog = React.createRef();
  const dialogDelete = React.createRef();

  const handleCheck = event => {
    let prodSel = idsSeleccionados;
    if (event.target.checked === true) {
      setIdsSeleccionados([...prodSel, event.target.value]);
    } else {
      prodSel = prodSel.filter(item => item !== event.target.value);
      setIdsSeleccionados(prodSel);
    }
  };

  const columns = [
    {
      Header: 'INFORMACIÓN DE PRODUCTOR',
      columns: [
        {
          Header: 'CLAVE',
          accessor: 'productor_clave_tx',
          sortable: false,
          minWidth: 50,
          Cell: cell => {
            return (
              <>
                <div className="form-check">
                  {parseInt(cell.row.original.confirmado) === 0 && (
                    <CheckboxList
                      name="productores"
                      value={cell.row.original.uuid_cuentas_bajas_solicitud}
                      handleCheck={handleCheck}
                      checked={idsSeleccionados.includes(cell.row.original.uuid_cuentas_bajas_solicitud)}
                    />
                  )}
                  <label className="form-check-label" htmlFor="flexCheckChecked" style={{ marginTop: 5, paddingLeft: 5 }}>
                    {cell.value}
                  </label>
                </div>
              </>
            );
          },
        },
        {
          Header: 'NOMBRE PRODUCTOR',
          accessor: 'productor_nombre',
          sortable: true,
          minWidth: 50,
          Cell: cell => (
            <Link
              to={{
                pathname: `/admin/cuentas/perfil/${cell.row.original.productor_uuid}`,
              }}
              className="m-r-2"
              style={{ color: '#789D16' }}>
              <span>{cell.value}</span>
            </Link>
          ),
        },
        {
          Header: 'LOCALIDAD',
          accessor: 'localidad',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'REGIÓN',
          accessor: 'region',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'MUNICIPIO',
          accessor: 'municipio',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'CÓDIGO',
          accessor: 'productor_codigo_tx',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'CATEGORÍA',
          accessor: 'cuenta_categoria',
          sortable: true,
          minWidth: 90,
          Cell: cell => <LabelCategory label={cell.value} color={cell.row.original.cuenta_categoria_color}></LabelCategory>,
        },
        {
          Header: 'MOTIVO DE LA BAJA',
          accessor: 'motivo_baja',
          sortable: true,
          minWidth: 90,
          // Cell: cell => (
          // 	<LabelCategory label={cell.value} color={cell.row.original.cuenta_categoria_color}></LabelCategory>
          // 	// <span className="badge rounded-4" style={{backgroundColor: cell.row.original.cuenta_categoria_color, fontSize: '0.75rem'}}>{cell.value}</span>
          // ),
        },
      ],
    },
    {
      Header: 'INFORMACIÓN PROGRAMA ORGÁNICO',
      columns: [
        {
          Header: 'FECHA INGRESO ORGÁNICO',
          accessor: 'productor_fecha_ingreso',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'FECHA INGRESO TRANSICIÓN',
          accessor: 'productor_fecha_transicion',
          sortable: true,
          minWidth: 50,
        },
        // {
        // 	Header: 'FECHA APLICACIÓN PROD. PROHIBIDOS',
        // 	accessor: 's3_cafeorganico_otrans_fechaprohibidos',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'PROD. PROHIBIDOS UTILIZADOS',
        // 	accessor: 's3_cafeorganico_otrans_insumosprohibidos',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'HAS TOTALES DE TERRENO',
        // 	accessor: 'parcela_superficie',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'HA CULTIVO CAFÉ',
        // 	accessor: 's3_cafeorganico_otrans_superficie',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'HA. CULTIVO ORGÁNICO',
        // 	accessor: 'has_cultivo_organico',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: '# PLANTAS TOTALES CAFÉ',
        // 	accessor: 's3_cafeorganico_otrans_numplantas',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'FECHA INSPECCIÓN INTERNA',
        // 	accessor: 's3_inspeccion_fecha',
        // 	sortable: true,
        // 	minWidth: 50
        // },
        // {
        // 	Header: 'NOMBRE INSPECTOR INTERN0',
        // 	accessor: 's1_lista_inspector_str',
        // 	sortable: true,
        // 	minWidth: 50
        // }
      ],
    },
    // {
    // 	Header: "SUPERFICIE CULTIVOS NO CAFÉ",
    //   columns: [
    // 		{
    // 			Header: 'AUTOCONSUMO',
    // 			accessor: 's2_autoconsumo_superficie',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'OTROS CULTIVOS',
    // 			accessor: 's2_otrocultivo_superficie',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'POTRERO',
    // 			accessor: 's2_potrero_superficie',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'BOSQUE',
    // 			accessor: 's2_bosque_superficie',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'ACAHUAL',
    // 			accessor: 's2_acahual_superficie',
    // 			sortable: true,
    // 			minWidth: 50
    // 		}
    // 	]
    // },
    // {
    // 	Header: "PARCELA 1 CULTIVO ORGÁNICO",
    //   columns: [
    // 		{
    // 			Header: 'NOMBRE DE PARCELA',
    // 			accessor: 'parcela_nombre',
    // 			sortable: true,
    // 			minWidth: 50,
    // 			Cell: cell => (
    // 				// <div className="with-btn text-nowrap">
    // 					<Link to={{pathname: `/admin/parcelas/perfil/${cell.row.original.parcela_uuid}`}} className="m-r-2" style={{color: '#789D16'}}>
    // 						<span>{cell.value}</span>
    // 					</Link>
    // 				// </div>
    // 			)
    // 		},
    // 		{
    // 			Header: '#DE PLANTAS',
    // 			accessor: 'parcela_plantas',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'CULTIVO ANTERIOR',
    // 			accessor: 'parcela_cultivo_anterior',
    // 			sortable: true,
    // 			minWidth: 50
    // 		},
    // 		{
    // 			Header: 'CULTIVO A CERTIFICAR',
    // 			accessor: 'parcela_cultivo_certificar',
    // 			sortable: true,
    // 			minWidth: 50
    // 		}
    // 	]
    // }
  ];

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'productor_clave_tx', label: 'CLAVE' },
      { value: 2, target: 'localidad', label: 'LOCALIDAD' },
      { value: 3, target: 'region', label: 'REGIÓN' },
      { value: 5, target: 'municipio', label: 'MUNICIPIO' },
      { value: 6, target: 'productor_codigo_tx', label: 'CÓDIGO' },
      { value: 7, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
      { value: 8, target: 'cuenta_categoria', label: 'CATEGORÍA' },
      { value: 9, target: 'motivo_baja', label: 'MOTIVO DE LA BAJA' },
      {
        value: 9,
        target: 'productor_fecha_ingreso',
        label: 'FECHA INGRESO ORGÁNICO',
      },
      {
        value: 10,
        target: 'productor_fecha_transicion',
        label: 'FECHA INGRESO TRANSICIÓN',
      },
    ],
    []
  );

  const getData = () => {
    setBlocking(true);
    Api.search('admin/sic/padron_bajas', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: ciclo.id },
        { column: 'confirmado', operator: '=', value: btnPendientes ? 0 : 1 },
      ],
    })
      .then(response => {
        setData(response.data);
        setOriginalData(response.data);
        setBlocking(false);
      })
      .catch(e => {
        setBlocking(false);
      });
  };

  const setFilter = value => {
    setCiclo(value.target);
  };

  const setDataFilter = data => {
    setData(data);
  };

  const getBackgroundColor = (i, j) => {
    if (i == 1) {
      return 'rgb(247, 239, 231)';
    } else {
      switch (j) {
        // case 0: return env.colors.neutral_600; break;
        case 1:
          return '#91918A';
        // case 2: return '#C7AE34';
        case 3:
          return '#91918A';
        default:
          return env.colors.neutral_600;
      }
    }
  };

  const getColor = i => {
    return i == 1 ? 'rgb(95, 95, 89)' : 'white';
  };

  const getPendientes = () => {
    setBtnPendientes(true);
  };

  const getHistorial = () => {
    setBtnPendientes(false);
  };

  useEffect(() => {
    if (ciclo?.id) {
      getData();
    }
  }, [btnPendientes, ciclo]);

  useEffect(() => {
    console.log(idsSeleccionados);
  }, [idsSeleccionados]);

  const enviarBaja = padronesSeleccionados => {
    if (idsSeleccionados.length > 0) {
      setBlocking(true);
      let data = {
        uuids: idsSeleccionados,
        id_ciclo: ciclo.id,
        padronesSeleccionados,
      };
      dialog.current.close();
      Api.create('admin/sic/confirmar_bajas', data)
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            setIdsSeleccionados([]);
            getData();
            setConfirmBajas(!confirmBajas);
            setBlocking(false);
            Swal.fire({
              icon: 'success',
              title: '',
              text: `Se ha confirmado la baja de ${idsSeleccionados.length} productores`,
            });
          }
        })
        .catch(e => {
          setBlocking(false);
        });
    }
  };

  const cancelarBaja = () => {
    if (idsSeleccionados.length > 0) {
      setBlocking(true);
      let data = { uuids: idsSeleccionados, id_ciclo: ciclo.id };
      dialogDelete.current.close();
      Api.create('admin/sic/cancelar_bajas', data)
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            setIdsSeleccionados([]);
            getData();
            setConfirmBajas(!confirmBajas);
            setBlocking(false);
            Swal.fire({
              icon: 'success',
              title: '',
              text: `Se ha cancelado la baja de ${idsSeleccionados.length} productores`,
            });
          }
        })
        .catch(e => {
          setBlocking(false);
        });
    }
  };

  return (
    <div>
      <div className="row mb-1">
        <div className="col-4">
          <SelectCiclo
            setFilter={evt => {
              setFilter(evt);
            }}></SelectCiclo>
        </div>
        <div className="col-8 d-flex justify-content-end">
          {ciclo?.uuid && auth.hasPermission('PADRON_BAJAS_EXPORTAR') && (
            <LinkDownload url={`xls/${report}/${ciclo?.uuid}`} label="Descargar Excel" icon={env.images.icon.xls}></LinkDownload>
          )}
        </div>
      </div>

      <div className="row justify-content-between mb-2">
        <TabButtons
          btnLeftHandle={() => getPendientes()}
          btnRightHandle={() => getHistorial()}
          btnDisabled={btnPendientes}
          btnLeftLabel="Pendientes"
          btnRightLabel="Historial"
        />
      </div>

      <CardContainer height={'100%'}>
        <ListToolbar left={<SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
          <BtnNuevo
            show={btnPendientes}
            icon={null}
            disabled={idsSeleccionados.length == 0}
            onClick={() => dialog.current.open()}>
            Dar de baja
          </BtnNuevo>
          <BtnCancelar show={btnPendientes} disabled={idsSeleccionados.length == 0} onClick={() => dialogDelete.current.open()}>
            Cancelar baja
          </BtnCancelar>
        </ListToolbar>

        <NoPagination
          blocking={blocking}
          columns={columns}
          data={data}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}></NoPagination>
      </CardContainer>
      <ModalPadronAltas
        ref={dialog}
        type="Baja"
        title="Confirmar baja de productores"
        onConfirm={padronesSeleccionados => {
          enviarBaja(padronesSeleccionados);
        }}></ModalPadronAltas>
      <ModalPadronAltasBajasCancelar
        ref={dialogDelete}
        type="bajas"
        title="Cancelar baja de productores"
        onConfirm={() => {
          cancelarBaja();
        }}></ModalPadronAltasBajasCancelar>
    </div>
  );
};

export default PadronBajasList;
